import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { flattenErrors } from './ErrorHelpers';

export class AddScheduledEventLocationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { renderModal, showModal } = this.state;

        return (
            <>
                <input onClick={() => this.setState({
                    showModal: true,
                    renderModal: true
                })} className="btn btn-primary" href="javascript:void(220221)"
                    value="Add Location"
                    type="button"
                />
                {renderModal &&
                    <AddScheduledEventLocationModalComponent
                        userId={this.props.userId}
                        showModal={showModal}
                        handleClose={() => {
                            this.setState({ showModal: false });
                        }}
                        onLocationAddComplete={this.props.onLocationAddComplete}
                        onExited={() => {
                            this.setState({ renderModal: false });
                        }} />}
            </>
        );
    }
}



class AddScheduledEventLocationModalComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            UserId: props.userId
        };
    }

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    save = (e) => {
        this.setState({
            isSaving: true,
            errors: null
        },
            () => {
                fetch(`/api/events/locations/create`,
                    {
                        method: "POST",
                        body: JSON.stringify(this.state),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(req => req.json())
                    .then(resp => {
                        if (resp.success) {
                            this.setState({ resp });
                            if (this.props.onLocationAddComplete) {
                                this.props.onLocationAddComplete(resp.id, this.state);
                            }
                            if (this.props.onExited) {
                                this.props.onExited();
                            }
                        } else if (resp.errors) {
                            if (resp.errors.detail) {
                                this.setState({
                                    errors: [resp.errors.detail],
                                    isSaving: false
                                });
                            } else {
                                const flattened = flattenErrors(resp.errors);
                                this.setState({
                                    errors: flattened,
                                    isSaving: false
                                });
                            }
                        } else {
                            this.setState({
                                errors: ["A general error occurred. Please contact your system administrator."],
                                isSaving: false
                            });
                        }
                    });
            });
    }


    render() {
        const { showModal, handleClose, onExited } = this.props;

        return (
            <Modal isOpen={showModal} onClosed={onExited}>
                <ModalHeader toggle={handleClose}>
                    Add Event Location
                </ModalHeader>
                <ModalBody>
                    {!this.state.resp && <div>
                        <div className="form-row">
                            <div className="form-group col-12">
                                <label className="sr-only">Name</label>
                                <input type="text" name="Name" value={this.state.Name} onChange={this.handleInputChange}
                                    placeholder="Enter Location Name" className="form-control" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-12">
                                <label className="sr-only">Address 1</label>
                                <input type="text" name="Address1" value={this.state.Address1} onChange={this.handleInputChange}
                                    placeholder="Address 1" className="form-control" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-12">
                                <label className="sr-only">Address 2</label>
                                <input type="text" name="Address2" value={this.state.Address2} onChange={this.handleInputChange}
                                    placeholder="Address2" className="form-control" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-12">
                                <label className="sr-only">City</label>
                                <input type="text" name="City" value={this.state.City} onChange={this.handleInputChange}
                                    placeholder="City" className="form-control" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-2 form-group">
                                <label className="sr-only">State</label>
                                <input type="text" name="State" className="form-control" maxlength="2" placeholder="State" value={this.state.State} onChange={this.handleInputChange} />
                            </div>
                            <div className="col-4 form-group">
                                <label className="sr-only">CVV Code</label>
                                <input type="tel" name="Zip" className="form-control" maxlength="5" placeholder="Zip" value={this.state.Zip} onChange={this.handleInputChange} />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-12">
                                <label className="sr-only">Directions</label>
                                <textarea name="Directions" className="form-control" placeholder="Directions" value={this.state.Directions} onChange={this.handleInputChange} rows={5} />
                            </div>
                        </div>
                    </div>}
                </ModalBody>
                <ModalFooter>
                    {!this.state.resp && <>
                        {this.state.isSaving && <div className="float-left">
                            Creating...
                        </div>}
                        {this.state.errors && <div className="float-left text-left">
                            {this.state.errors.map(e => <div key={e}>{e}</div>)}
                        </div>}
                        <Button onClick={this.save} disabled={this.state.isSaving}>
                            Create
                        </Button>
                    </>}
                    {this.state.resp && <Button onClick={this.props.handleClose}>
                        Cancel
                    </Button>}
                </ModalFooter>
            </Modal>
        );
    }
}